import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, shareReplay } from 'rxjs/operators';
import { ARSDto } from 'src/app/models/structure-dto.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.prod';
import { HabilitationDto } from 'src/app/models/habilitation-dto.model';
import { HabilitationType } from 'src/app/models/habilitation-type.model';

@Injectable({ providedIn: 'root' })
export class ARSCacheService {

  private arsList: Observable<ARSDto[]> | null = null;
  private arsListValue: ARSDto[] = [];

  constructor(private readonly httpClient: HttpClient) {}

  getARSListFromAPI(): Observable<ARSDto[]> {
    return this.httpClient.get<ARSDto[]>(`${environment.API_URL}contrats/ars`);
  }

  getARSList(): Observable<ARSDto[]> {
    if (!this.arsList) {
       this.arsList = this.getARSListFromAPI().pipe(
        tap((structuresARSList: ARSDto[]) => this.arsListValue = structuresARSList),
        shareReplay(1) // sauvegarde le dernier valeur et le réutilise
      );
    }
    return this.arsList;
  }

  existeStructureARSAppartenantUtilisateur(habilitations: HabilitationDto[]) : boolean {
    if (!this.arsListValue?.length) {
      this.getARSList().subscribe({
        next: (arsList: ARSDto[]) => {
          this.arsListValue = arsList ?? [];
        }
      });
     }
    const arsIdsFromTableARS = new Set(this.arsListValue.map(ars => String((ars.typeStructure ?? '').trim() + String(ars.idStructure ?? '').trim())));
    return habilitations.some(h =>
      arsIdsFromTableARS.has((h.structure?.typeStructure ?? '').trim() + (h.structure?.idStructure ?? '').trim()) &&
      [HabilitationType.MANDATAIRE, HabilitationType.REPRESENTANT_LEGAL]
        .includes(h.roleMetier?.code as HabilitationType)
      );
  }


}
